import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_glp_upsell_fakedoor~1
			upsell: {
				routeNames: [
					'upsell-static-subscription-activated-no-bonus',
					'upsell-static-glp-intro',
					'upsell-static-glp-loader',
					'upsell-static-glp-onboarding',
					'upsell-static-glp-treatment-loader',
					'upsell-static-glp-offer',
					'upsell-static-glp-checkout',
					'upsell-static-glp-preview',
					'upsell-static-glp-result',
				],
			},
		},
	},
]

export default config
